import IdCardUpload from '@shared/IdCardUpload/IdCardUpload'
import { Col, Row } from 'antd'
import UserInfoForm from './UserInfoForm'
import { useIdCardFileUploadMutation } from '@app/store/reducers/configs/idCardFileUpload.api'
import { useController, useFormContext } from 'react-hook-form'
import { useEffect, useRef } from 'react'
import { useBusinessCardOrderDetailMutation } from '@app/store/reducers/salaryCards/businessCardOrder.api'

function UserInformation() {
  const [uploadFile, {}] = useIdCardFileUploadMutation()
  const { setValue, control } = useFormContext()

  const [_, { data: detailInformationList }] =
    useBusinessCardOrderDetailMutation({
      fixedCacheKey: 'businessCardOrderDetail',
    })

  const {
    fieldState: { invalid },
  } = useController({ name: 'frontFileId', control })

  const ref = useRef<any>(null)

  useEffect(() => {
    invalid && ref.current.reset()
  }, [invalid])

  useEffect(() => {
    if (detailInformationList) {
      if (detailInformationList.front) {
        ref.current?.setFile('front', detailInformationList.front)
      }
      if (detailInformationList.back) {
        ref.current?.setFile('back', detailInformationList.back)
      }
    }
  }, [detailInformationList])

  return (
    <Row
      style={{
        width: '100%',
        borderRadius: '16px',
        backgroundColor: '#F3F6FA',
        padding: '24px 36px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Col span={10}>
        <UserInfoForm />
      </Col>
      <Col span={12}>
        <IdCardUpload
          ref={ref}
          optional={invalid}
          uploadFile={async (file, slot) => {
            const formData = new FormData()
            formData.append('file', file)

            const fileRes = await uploadFile(formData)

            return { id: fileRes.data.uniqueFileId }
          }}
          onIdsChange={({ back, front }) => {
            setValue(`frontFileId`, front, { shouldValidate: true })
            setValue(`backFileId`, back, { shouldValidate: true })
          }}
        />
      </Col>
    </Row>
  )
}

export default UserInformation
